// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Ny8V","notes":"Notes_notes__2LMv8"};